import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { MenuCheckbox } from "./MenuCheckbox";
export var MenuSwitch = React.forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(MenuCheckbox, _extends({
    ref: forwardedRef,
    variant: "switch"
  }, props));
});